import React from "react";

const UserRetentionSummaryCard = ({
  totalBookings = 0,
  newUsers = 0,
  retainedUsers = 0,
  onCustomerTypeClick,
}) => {
  const retentionRate =
    newUsers + retainedUsers > 0
      ? Math.round((retainedUsers / (newUsers + retainedUsers)) * 100)
      : 0;

  return (
    <div className="w-[95%] xl:w-1/3 bg-[#6366F1] rounded-3xl p-7 flex flex-col gap-6 shadow-lg">
      
      {/* Header */}
      <div className="flex items-center gap-4">
        <img
          src="/Assets/dashboard-1.png"
          alt="User Retention"
          className="w-11 h-11"
        />
        <div>
          <p className="text-white text-sm font-medium">
            User Retention Overview
          </p>
          <p className="text-white text-2xl font-bold">
            {newUsers + retainedUsers} Users
          </p>
        </div>
      </div>

      <div className="w-full h-[1px] bg-white/30" />

      {/* New Users */}
      <div
        onClick={() => onCustomerTypeClick?.("NEW")}
        className="cursor-pointer bg-white rounded-xl p-4 flex justify-between items-center hover:scale-105 transition"
      >
        <div>
          <p className="text-blue-600 text-sm font-semibold">
            New Users
          </p>
          <p className="text-xs text-gray-500">
            First-time completed bookings
          </p>
        </div>
        <p className="text-[#39354E] font-bold text-lg">
          {newUsers}
        </p>
      </div>

      {/* Retained Users */}
      <div
        onClick={() => onCustomerTypeClick?.("EXISTING")}
        className="cursor-pointer bg-white/90 rounded-xl p-4 flex justify-between items-center hover:scale-105 transition"
      >
        <div>
          <p className="text-green-600 text-sm font-semibold">
            Retained Users
          </p>
          <p className="text-xs text-gray-500">
            Users with previous completed booking
          </p>
        </div>
        <p className="text-[#39354E] font-bold text-lg">
          {retainedUsers}
        </p>
      </div>

      <div className="w-full h-[1px] bg-white/30" />

      {/* Retention Rate */}
      <div className="bg-[#1E1B4B] rounded-xl p-4 flex justify-between items-center">
        <div>
          <p className="text-white text-sm font-semibold">
            Retention Rate
          </p>
          <p className="text-xs text-white/70">
            Retained / Total Bookings
          </p>
        </div>
        <p className="text-white font-bold text-lg">
          {retentionRate}%
        </p>
      </div>
    </div>
  );
};

export default UserRetentionSummaryCard;